module.exports = __webpack_public_path__ + "static/media/COTSLogo.c622bfe0.png";